// extracted by mini-css-extract-plugin
export default {"select":"Select_select__E+G2z","titleHeaderselect":"Select_titleHeaderselect__sO71U"};